import { setProductDetails } from "../redux/slices";
import { productActionTypes } from "../redux/utils";
import { useAPI } from "../hooks";
// Handles when user wants to create another return request
const raiseANewRequest = async (
  productDetailsState,
  settingState,
  dispatch
) => {
  const orderID = productDetailsState?.orderNumber;
  const { ECORETURNS_ORDER_VALIDATION_API, PROCESS_RETURN_API } = useAPI();
  const FINAL_API_CALL =
    storeConfigState.platform === "shopify"
      ? PROCESS_RETURN_API
      : ECORETURNS_ORDER_VALIDATION_API;

  const response = await fetch(FINAL_API_CALL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      is_ajax: true,
      customer_email: productDetailsState?.customerEmail,
      order_number: orderID,
      shop: settingState?.storeUniqueID,
    }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();

  dispatch(
    setProductDetails({
      key: productActionTypes?.SET_RETURN_REASON,
      value: data?.return_reasons,
    })
  );

  dispatch(
    setProductDetails({
      key: productActionTypes?.SET_RECENT_ORDER_ID,
      value: data?.recent_order_id,
    })
  );

  // Setting new product items
  dispatch(
    setProductDetails({
      key: productActionTypes?.SET_ORDER_INFO,
      value: data?.order_data,
    })
  );
};

// Get remaining items to be updated in Order info
const getUpdatedOrderInfo = (
  productDetailsState,
  selectedProductDetailsState
) => {
  // Find the selected item from product list
  let selectedProduct = productDetailsState?.orderInfo?.find(
    (product) => product?.variant_id === selectedProductDetailsState?.variantID
  );
  // Subtract the selected quantity from total quantity
  const remainingQuantityOfSelectedProduct =
    selectedProduct?.quantity -
    parseInt(selectedProductDetailsState?.selectedQuantity);

  // Filter the item from product list
  let updatedOrderInfo = productDetailsState.orderInfo.filter(
    (product) => product?.variant_id !== selectedProductDetailsState?.variantID
  );

  // Check if remaining quantity > 0 => Update the product with new quantity
  if (remainingQuantityOfSelectedProduct > 0) {
    // Update new quantity for the item
    selectedProduct = {
      ...selectedProduct,
      quantity: remainingQuantityOfSelectedProduct,
    };

    // Push updated item into product list
    updatedOrderInfo?.push(selectedProduct);
  }

  return updatedOrderInfo;
};

export { raiseANewRequest, getUpdatedOrderInfo };
